export default import.meta.ROLLDOWN_FILE_URL_YYBwpw5x5TUaWMuuqY8pNg